<mat-toolbar *ngIf="length > 0">
  <span *ngIf="!hidePageSize">
    <span class="page-info">{{ titleKey | translate }}</span>
    <mat-select class="selector" [(ngModel)]="pageOffset" (selectionChange)="updatePageSize()">
      <mat-option [value]="5">5</mat-option>
      <mat-option [value]="10">10</mat-option>
      <mat-option [value]="20">20</mat-option>
      <mat-option [value]="50">50</mat-option>
    </mat-select>
  </span>

  <span>
    <button [disabled]="pageIndex <= 1" (click)="getFirstPage()">
      <mat-icon>first_page</mat-icon>
    </button>
    <button [disabled]="pageIndex <= 1" (click)="getPreviousPage()">
      <mat-icon matSuffix>chevron_left</mat-icon>
    </button>
    <span class="page-info"> {{ 1 + (pageOffset * (pageIndex - 1)) }}
      - {{ (pageOffset * pageIndex) <= length ? pageOffset * pageIndex : length }}
      de {{ length }}</span>
    <button [disabled]="this.pageOffset * this.pageIndex >= length" (click)="getNextPage()">
      <mat-icon matSuffix>chevron_right</mat-icon>
    </button>
    <button [disabled]="this.pageOffset * this.pageIndex >= length" (click)="getLastPage()">
      <mat-icon>last_page</mat-icon>
    </button>
  </span>
</mat-toolbar>
